<template>
  <div class="input-password">
    <input
      :id="id"
      v-bind="$attrs"
      ref="input"
      v-model="model"
      :autocomplete="props.autocomplete"
      :disabled="props.disabled"
      :placeholder="$t(props.placeholder ?? 'placeholder.default')"
      class="input-password__input form__input"
      :class="{ 'is-invalid': validationUtils?.invalid }"
      :type="showPassword ? 'text' : 'password'"
      @blur="onBlur($event)"
    />
    <button
      type="button"
      class="input-password__button"
      :class="{ 'input-password__button--on': showPassword }"
      :title="$t('common.showPassword')"
      :disabled="props.disabled"
      @pointerdown="!props.disabled && (showPassword = true)"
      @pointerout="!props.disabled && (showPassword = false)"
      @pointerup="!props.disabled && (showPassword = false)"
      @keydown.space="!props.disabled && (showPassword = true)"
      @keyup.space="!props.disabled && (showPassword = false)"
      @keydown.enter="!props.disabled && (showPassword = true)"
      @keyup.enter="!props.disabled && (showPassword = false)"
    >
      {{ $t("common.showPassword") }}
    </button>
  </div>
</template>

<script lang="ts">
export default {
  inheritAttrs: false,
};
</script>
<script lang="ts" setup>
import { computed, ComputedRef, inject, ref } from "vue";
import { ValidationUtils } from "@/types";

const props = defineProps<{
  autocomplete: string;
  modelValue: string;
  placeholder?: string;
  disabled?: boolean;
}>();

const emit = defineEmits<{
  (e: "update:modelValue", value: string): void;
}>();

const showPassword = ref(false);
const validationUtils =
  inject<ComputedRef<ValidationUtils>>("field-validation");
const id = inject<string>("field-id");

const model = computed({
  get: () => props.modelValue ?? "",
  set: (input: string) => {
    const value = input.trim();
    emit("update:modelValue", value);
    validationUtils?.value.onChange(value);
  },
});

const onBlur = (event: FocusEvent) => {
  const input = event.target as HTMLInputElement;
  if (input.value.trim() !== input.value) {
    input.value = input.value.trim();
  }

  validationUtils?.value.touch();
};
</script>
